const headers = {
  name: "Closing Balances",
  components: [
  ],
  navigate: {
    tabs: [
      { name: "Closing Balances", path: "/app/settings/closing-balance" },
      {name : "Add" , path :""}
    ],
  },
};

export default headers;